/**
 * @generated SignedSource<<5d9ee8e78310c8c4941671436d7316ab>>
 * @relayHash c9df175083f220403fce9a22927da6ca
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9df175083f220403fce9a22927da6ca

import { ConcreteRequest } from 'relay-runtime';
export type PregnancyStatus = "NOT_PREGNANT" | "PREGNANT" | "UNKNOWN";
export type De_updatePatientGynaecologyInput = {
  firstPeriodAtYear?: number | null;
  menopauseSinceYear?: number | null;
  patientId: string;
  pregnancyHistory?: string | null;
  pregnancyStatus: PregnancyStatus;
  weeksOfPregnancy?: number | null;
};
export type deUpdateAllPatientGynaecologyMutation$variables = {
  input: De_updatePatientGynaecologyInput;
};
export type deUpdateAllPatientGynaecologyMutation$data = {
  readonly updateAllPatientGynaecology: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly gynaecology: {
      readonly firstPeriod: number | null;
      readonly id: string;
      readonly menopauseSince: number | null;
      readonly patientId: string;
      readonly pregnancy: PregnancyStatus;
      readonly pregnancyHistory: string | null;
      readonly weeksOfPregnancy: number | null;
    } | null;
  };
};
export type deUpdateAllPatientGynaecologyMutation = {
  response: deUpdateAllPatientGynaecologyMutation$data;
  variables: deUpdateAllPatientGynaecologyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "Error",
  "abstractKey": "__isError"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "IneligibleForGynaecology",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*:: as any*/),
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Gynaecology",
  "kind": "LinkedField",
  "name": "gynaecology",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "menopauseSince",
      "storageKey": null
    },
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pregnancy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pregnancyHistory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weeksOfPregnancy",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUpdateAllPatientGynaecologyMutation",
    "selections": [
      {
        "alias": "updateAllPatientGynaecology",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientGynaecologyPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientGynaecology",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUpdateAllPatientGynaecologyMutation",
    "selections": [
      {
        "alias": "updateAllPatientGynaecology",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientGynaecologyPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientGynaecology",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c9df175083f220403fce9a22927da6ca",
    "metadata": {},
    "name": "deUpdateAllPatientGynaecologyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "72763263c61512ef27648c609cda07c3";

export default node;
